import React, { useState } from 'react'
import { connect } from 'react-redux'
import EditUserEmailForm from '../../../components/forms/account/EditUserEmailForm'
import { requestEmailUpdate } from '../../../actions/user'
import getErrorMessageForRequest from '../../../utils/getErrorMessageForRequest'

function UpdateEmailContainer(props) {
  const {
    user, requestEmailUpdate,
  } = props
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [recaptchaFailed, setRecaptchaFailed] = useState(false)
  const [pendingEmail, setPendingEmail] = useState('')

  function onPreSubmit() {
    setSubmitLoading(true)
  }

  function onSubmit(formData) {
    const requestData = {
      email: formData.email,
      password: formData.currentPassword,
      recaptchaResponse: formData.recaptchaResponse,
    }
    setSubmitLoading(true)
    setErrorMessage('')
    requestEmailUpdate(requestData, user.id)
      .then(() => {
        setSubmitLoading(false)
        setPendingEmail(formData.email)
      })
      .catch((error) => {
        setSubmitLoading(false)
        setErrorMessage(getErrorMessageForRequest({ requestName: 'requestEmailUpdate', response: error.response }))
      })
  }

  if (pendingEmail) {
    return (
      <div className='accountForm-pendingEmailConfirmation'>
        <div className='accountForm-pendingEmailConfirmation-title'>
          Confirm your new email
        </div>
        <div className='accountForm-pendingEmailConfirmation-body'>
          We’ve sent a confirmation link to
          {' '}
          <span className='accountForm-pendingEmailConfirmation-email'>{pendingEmail}</span>
          . Click the link in that email to finish updating your Plickers email address.
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>

      <EditUserEmailForm
        currentEmail={user.email}
        onPreSubmit={() => onPreSubmit()}
        onSubmit={(formData) => onSubmit(formData)}
        submitLoading={submitLoading}
        onRecaptchaError={() => setRecaptchaFailed(true)}
      />

      {recaptchaFailed && (
        <div className='accountForm-error accountForm-error--recaptcha'>
          <div>
            This form requires reCAPTCHA but it failed to load.
          </div>
          <div>
            Ensure google.com/recaptcha/api.js is not blocked by your browser or network.
          </div>
        </div>
      )}

      {errorMessage && (
        <div className='accountForm-error'>
          {errorMessage}
        </div>
      )}

    </React.Fragment>
  )
}

export default connect(
  (state) => ({
    user: state.user,

  }),
  { requestEmailUpdate },
)(UpdateEmailContainer)
